import moment from 'moment';

export const getRemainingMonths = (target) =>
  moment(target?.creationData?.date).diff(moment(), 'months');

export const getPassedMonths = (target) => moment().diff(moment(target?.createData), 'months');
